import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getFeatureFlag } from 'ggx-service/feature-flag/selectors'
import { useTranslation } from 'react-i18next'
export default {
  useFeatureFlagRequireMerchantOrderNote() {
    return useSelector(state =>
      getFeatureFlag({ state, featureFlag: 'require_merchant_order_note' })
    )
  },
  useRequireMerchantOrderNoteValidator(validator) {
    const featureFlagRequireMerchantOrderNote = this.useFeatureFlagRequireMerchantOrderNote()
    const [t] = useTranslation()
    return useMemo(() =>
      featureFlagRequireMerchantOrderNote ?
        validator.concat([value => {
          const trimmedValue = value?.trim()
          return trimmedValue?.length ? undefined : t('the_field_is_required')
        }]) :
        validator,
      [validator, featureFlagRequireMerchantOrderNote, t]
    )
  },
}
